/* eslint-disable no-debugger */
/* eslint-disable default-param-last */
import { ProductConstants } from '../actions/actionType';

export function offerData(state = {}, action,product) {
    switch (action.type) {
    case ProductConstants.OFFER_DATA_SUCCESS:
        return {...state,
            type: ProductConstants.OFFER_DATA_SUCCESS,
            items: action.user,
            products:action.product,
            orderValue:action.orderValue
        };
    case ProductConstants.OFFER_DATA_FAILURE:
        return {
            type: ProductConstants.OFFER_DATA_SUCCESS,
            message: action.message,
        };
    case ProductConstants.CART_SELECTED_ITEM:
        return {...state,
            selected:action.user.data
                
        };
        
    default:
        return state;
    }
}
